import React from 'react'
import ShakaPlayer from 'shaka-player-react'
import 'shaka-player/dist/controls.css'

const Player = React.memo(({url}) => {
  return <ShakaPlayer width={200} src={url} />
})

export default Player
